exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#nature-of-problem__container[data-v-194af80b] {\n  overflow: hidden;\n  -webkit-transition: height 2s;\n  /* For Safari 3.1 to 6.0 */\n  transition: height 2s;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/ticket/components/ticket-modal-nature-of-problem/styles.scss"],"names":[],"mappings":";AAEE;EACE,iBAAgB;EAChB,8BAA6B;EAC7B,2BAA2B;EAC3B,sBAAqB;CACtB","file":"styles.scss","sourcesContent":["\n#nature-of-problem {\n  &__container {\n    overflow: hidden;\n    -webkit-transition: height 2s;\n    /* For Safari 3.1 to 6.0 */\n    transition: height 2s;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-194af80b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/ticket/components/ticket-modal-nature-of-problem/styles.scss
// module id = YL3h
// module chunks = 0